module.exports = __webpack_public_path__ + "static/media/footer_logo.37210be2.svg";